module.exports = __webpack_public_path__ + "img/videos.1b943359.svg";